module.exports = __webpack_public_path__ + "media/Tapping Send A Text Button.020426ea.mp3";